import React, { useEffect, useRef, useState } from "react";
import styles from "./index.module.scss";
import SortModel from "./sort-model";
import { useNavigate } from "react-router-dom";
import SortMobile from "./sort-mobile";

export default function InvestorHeader() {
  const [showModel, setShowModel] = React.useState(false);
  const navigate = useNavigate();
  const op: any = useRef(null);
  const [isMobile, setIsMobile] = useState(false);
  const handleResize = () => {
    if (window.innerWidth <= 768) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };
  useEffect(() => {
    setIsMobile(window.innerWidth <= 768 ? true : false);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className={styles.header}>
      <div className={styles.back}>
        <img
          className={styles.tag}
          src="/images/back.svg"
          alt=""
          onClick={() => {
            navigate(-1);
          }}
        />
      </div>
      <div className={styles.title}>Investors Exchange</div>
      <img
        src="/images/exc-icon.svg"
        width={24}
        alt="exc"
        className={styles.excIcon}
        onClick={(e) => {
          if (isMobile) {
            setShowModel(!showModel);
            return;
          } else if (op?.current) {
            op?.current.toggle(e);
          }
        }}
      />
      <SortMobile showModel={showModel} setShowModel={setShowModel} />
      <SortModel popRef={op} />
    </div>
  );
}
